import React from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import Typed from 'react-typed'
import { makeStyles } from '@material-ui/core/styles'
import CustomTypography from './CustomTypography'
const useStyles = makeStyles(() => ({
  root: {},
}))

const TypedText = (props) => {
  const { className, typedProps, ...rest } = props

  const classes = useStyles()

  return (
    <CustomTypography
      className={clsx('typed-text', classes.root, className)}
      {...rest}
    >
      <Typed className="typed-text__item" {...typedProps} />
    </CustomTypography>
  )
}

TypedText.propTypes = {
  className: PropTypes.string,
  typedProps: PropTypes.object.isRequired,
}

export default TypedText
